import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'

interface LoaderProps {
  inline: boolean
}

export const StyledLoader = styled.div<LoaderProps>`
  align-items: center;
  cursor: progress;
  display: flex;
  height: 100%;
  justify-content: ${({ inline }) => (inline ? 'left' : 'center')};
  width: 100%;
  min-width: 3.031vw;
  top: 0;
`

const ballDimensions = (() => {
  const min = 8
  const max = 24

  let styles = `
    height: ${min}px;
    width: ${min}px;
  `

  for (let i = min; i <= max; i++) {
    styles += `
      @media (min-width: ${i * 160}px) {
        height: ${i}px;
        width: ${i}px;
      }
    `
  }

  for (let i = max; i >= min; i--) {
    styles += `
      @media (max-width: ${i * 45 - 1}px) {
        height: ${i}px;
        width: ${i}px;
      }
    `
  }

  return styles
})()

interface LoaderBallProps {
  n?: 1 | 2
  color?: string
}

export const LoaderBall = styled.span<LoaderBallProps>`
  will-change: opacity;
  border-radius: 50%;
  background-color: ${({ color }) => color || 'currentColor'};
  display: inline-block;
  animation: loading 0.7s ease-in infinite alternate;
  ${ballDimensions};
  ${({ n }) => {
    if (n === 1) {
      return 'animation-delay: 0.33s;'
    }

    if (n === 2) {
      return 'animation-delay: 0.66s;'
    }

    return ''
  }}

  &:not(:last-of-type) {
    margin-right: 0.39vw;

    ${iPadDown} {
      margin-right: 1.2vw;
    }
  }
`
